import React, { useState, useEffect } from 'react';
import { Table, Tag } from 'antd';
import { fetchArticleSteps } from 'api/articleservice';
import '../css/ArticleTable.css';
const ArticleHistoryTable = ({articleId}) => {

    const [steps, setSteps] = useState([]);

    useEffect(() => {

        fetchArticleSteps(articleId).then((data) => {
            setSteps(data || {})
            })
            .catch((err) => console.error("Error fetching article:", err));
          
    }, [articleId]); 

    const data = Array.isArray(steps)
     ? steps.map((step, i) => ({
        key: String(i + 1),
        status: step.statusTitle || '',
        role: step.role || '',
        name: step.fullName || '',
        createddate: step.createdDate ? step.createdDate.split("T")[0] : '',
        dateOfCompletion: step.dateOfCompletion ? step.dateOfCompletion.split("T")[0] : '',
    })): [];


    const columns = [
        {
            title: "Status",
            key: "status",
            dataIndex: "status",
            // render: (status) => {
            //     let color = "default";
            //     switch (status) {
            //         case "active":
            //             color = "green";
            //             break;
            //         case "Evaluation":
            //             color = "orange";
            //             break;
            //         case "banned":
            //             color = "red";
            //             break;
            //         default:
            //             color = "green";
            //     }
            //     return <Tag color={color}>{status.toUpperCase()}</Tag>;
            // },
      
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
        
        },
        {
            title: 'Full Name',
            dataIndex: 'name',
            key: 'name',
      
          
        },
        {
            title: 'Created Date',
            dataIndex: 'createddate',
            key: 'createddate',
     
          
        },
        {
            title: 'Date of Completion',
            dataIndex: 'dateOfCompletion',
            key: 'dateOfCompletion',
        },
    ];

    return (
        <Table columns={columns} dataSource={data} rowClassName={() => 'custom-row-hover'}  />
    );
};

export default ArticleHistoryTable;
